import React from 'react';
import { Button, Col, Grid, Row } from "react-bootstrap";
import { connect } from 'react-redux';
import { withHandlers, withStateHandlers } from "recompose";
import { bindActionCreators, compose } from "redux";
import { PublisherStatus } from "../../../../../constants";
import { adminActions } from '../../../../../state/modules/admin';
import { eventHandler } from "../../../../../utils";
import { InputFormField } from "../../../../components";

const PublisherCreate = ({
  onSubmit,
  publisherName,
  setPublisherName
}) => (
    <Grid>
      <Row>
        <Col xs={12} md={8} mdOffset={2}>
          <h1>Create new publishers</h1>
        </Col>
      </Row>
      <Row>
        <form noValidate onSubmit={eventHandler(onSubmit)}>
          <fieldset>
            <Col xs={12} md={8} mdOffset={2}>
              <InputFormField {...{
                id: 'publisher',
                label: 'New publisher name',
                required: true,
                value: publisherName,
                onChange: (e) => setPublisherName(e.target.value)
              }} />
            </Col>
            <Col xs={10} xsOffset={1} md={6} mdOffset={3}>
              <Button type='submit' className='large filled'>Add publisher</Button>
            </Col>
          </fieldset>
        </form>
      </Row>
    </Grid>
  )

const mapDispatchToProps = (dispatch) => ({
  addPublisher: bindActionCreators(adminActions.admin.addPublisher, dispatch)
})

export default compose(
  connect(null, mapDispatchToProps),
  withStateHandlers(() => ({
    publisherName: ''
  }), {
      setPublisherName: () => (newPublisherName) => ({
        publisherName: newPublisherName,
      })
    }),
  withHandlers({
    onSubmit: ({ addPublisher, publisherName }) => (e) => {
      addPublisher(publisherName, PublisherStatus.active)
    }
  })
)(PublisherCreate)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/publisher-portal/partials/publisher-create.js